module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"releaseNotes":"Release Notes","version":"Version","changeTypes":{"additions":"Neu hinzugefügt","extensions":"Erweiterungen","upgrades":"Aktualisierungen","fixes":"Verbesserungen"}}}')
  delete Component.options._Ctor
}
